import { IRadioBlockItem } from "common/components/RadioBlockItem/RadioBlockItem";

export const roleNames: { [id: number]: string } = {
  1: "Authenticated",
  2: "Public",
  3: "SuperAdmin",
  4: "Administrateur",
  5: "Pro",
};
export const rolesData: IRadioBlockItem[] = [
  // {
  //   id: 1,
  //   icon: "BsStar",
  //   titleKey: "roles.Authenticated",
  //   subtitleKey: "roles.AuthenticatedSubtitle",
  //   color: "#29c1dbff",
  // },
  {
    id: 5,
    icon: "BsStarHalf",
    titleKey: "roles.Pro",
    subtitleKey: "roles.ProSubtitle",
    color: "#60A5FA",
  },
  {
    id: 4,
    icon: "BsStarFill",
    titleKey: "roles.Administrateur",
    subtitleKey: "roles.AdministrateurSubtitle",
    color: "#1D4ED8",
  },
];

export const superRolesData: IRadioBlockItem[] = [
  {
    id: 1,
    icon: "BsStar",
    titleKey: "roles.Authenticated",
    subtitleKey: "roles.AuthenticatedSubtitle",
    color: "#29c1dbff",
  },
  {
    id: 5,
    icon: "BsStarHalf",
    titleKey: "roles.Pro",
    subtitleKey: "roles.ProSubtitle",
    color: "#60A5FA",
  },
  {
    id: 4,
    icon: "BsStarFill",
    titleKey: "roles.Administrateur",
    subtitleKey: "roles.AdministrateurSubtitle",
    color: "#1D4ED8",
  },
  {
    id: 3,
    icon: "BsStarFill",
    titleKey: "roles.SuperAdmin",
    subtitleKey: "roles.SuperAdminSubtitle",
    color: "#4c1d95",
  },
];

export default rolesData;
